import React, { Component } from "react";
import VideoThumbnail from "../VideoThumbnail/VideoThumbnail";

export default class AwardsVideoList extends Component {
  render() {
    return (
      <div className="awards">
        {Object.entries(this.props.awards).map(
          ([awardId, award]) =>
            this.props.videos[award.video] && (
              <div key={awardId} className="award-item">
                <h3>{award.name}</h3>
                <VideoThumbnail
                  competitionSlug={this.props.competitionSlug}
                  video={this.props.videos[award.video]}
                  awardMode
                  id={award.video}
                />
              </div>
            )
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AwardsVideoList/AwardsVideoList.js